import React, {Component} from 'react';
import {observer,inject} from "mobx-react";

class CommentsRefresher extends Component {
  render() {
    return (
      <div className="pf pointer bg-pc1-op50 bg-pc1-hover w1-op50 w1-hover" style={{ top: '50%', right: 0, zIndex:10100 }}>
        {this.props.commentsStore.selected_comment?(
            <div className="tac vpadd2 bo-w1-op70 solid1-bottom fs18 lh14 mdi mdi-comment-search-outline" onClick={()=>{ this.props.commentsStore.moveToSelectedCommentInStore(); }}></div>
        ):null}
        <div className="mdi mdi-refresh lh10 fs32 padd2" onClick={()=>{ this.props.commentsStore.loadComments(); }} ></div>
        {this.props.commentsStore.new_comments>0?(
          <div className="tac vpadd2 bo-w1-op70 solid1-top fs14 lh14" onClick={()=>{ this.props.commentsStore.moveToNextNewComment(); }}>
            {this.props.commentsStore.new_comments}
          </div>
        ):null}
      </div>
    )
  }
}

export default inject("commentsStore")(observer(CommentsRefresher));